import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputSwitch } from 'primereact/inputswitch';
import GenericFileUpload from '../../../../components/common/GenericFileUpload';
import { useLanguage } from '../../../../contexts/LanguageContext';

const PDF_TYPES = { 'application/pdf': ['.pdf'] };

const TrainingDocumentAddDialog = ({ visible, onHide, formik, vehicleOptions, trainingOptions, loadingVehicles, loadingTrainings, loading, onVehicleChange, onFilesChange }) => {
    const { th } = useLanguage();
    const invalid = (field) => formik.touched[field] && Boolean(formik.errors[field]);

    const footer = (
        <div>
            <Button type="button" label={th('common.cancel')} icon="pi pi-times" outlined onClick={onHide} disabled={loading} />
            <Button type="button" label={th('common.save')} icon="pi pi-check" onClick={formik.submitForm} loading={loading} disabled={loading} />
        </div>
    );

    return (
        <Dialog visible={visible} onHide={onHide} header={th('lmsTrainingDocument.addTitle')} footer={footer} modal className="p-fluid" style={{ width: '50rem', maxWidth: '95vw' }}>
            <div className="grid">
                <div className="field col-12 md:col-6">
                    <label htmlFor="vehicleCode">
                        {th('lmsTrainingDocument.vehicleModel')} <span className="text-red-500">*</span>
                    </label>
                    <Dropdown
                        inputId="vehicleCode"
                        value={formik.values.vehicleCode}
                        options={vehicleOptions}
                        onChange={(event) => onVehicleChange(event.value)}
                        onBlur={() => formik.setFieldTouched('vehicleCode', true)}
                        placeholder={th('lmsTrainingDocument.selectVehicle')}
                        loading={loadingVehicles}
                        filter
                        className={invalid('vehicleCode') ? 'p-invalid' : ''}
                    />
                    {invalid('vehicleCode') && <small className="p-error">{formik.errors.vehicleCode}</small>}
                </div>

                <div className="field col-12 md:col-6">
                    <label htmlFor="vehicleTrainingMatchId">
                        {th('lmsTrainingDocument.trainingType')} <span className="text-red-500">*</span>
                    </label>
                    <Dropdown
                        inputId="vehicleTrainingMatchId"
                        value={formik.values.vehicleTrainingMatchId}
                        options={trainingOptions}
                        onChange={(event) => formik.setFieldValue('vehicleTrainingMatchId', event.value)}
                        onBlur={() => formik.setFieldTouched('vehicleTrainingMatchId', true)}
                        placeholder={th('lmsTrainingDocument.selectTraining')}
                        loading={loadingTrainings}
                        disabled={!formik.values.vehicleCode}
                        filter
                        className={invalid('vehicleTrainingMatchId') ? 'p-invalid' : ''}
                    />
                    {invalid('vehicleTrainingMatchId') && <small className="p-error">{formik.errors.vehicleTrainingMatchId}</small>}
                </div>

                <div className="field col-12">
                    <label htmlFor="description">
                        {th('lmsTrainingDocument.description')} <span className="text-red-500">*</span>
                    </label>
                    <InputTextarea id="description" name="description" value={formik.values.description} onChange={formik.handleChange} onBlur={formik.handleBlur} rows={4} autoResize className={invalid('description') ? 'p-invalid' : ''} />
                    {invalid('description') && <small className="p-error">{formik.errors.description}</small>}
                </div>

                <div className="field col-12">
                    <label htmlFor="isPublic">{th('lmsTrainingDocument.visibility')}</label>
                    <div className="flex align-items-center gap-2">
                        <InputSwitch inputId="isPublic" checked={formik.values.isPublic} onChange={(event) => formik.setFieldValue('isPublic', event.value)} disabled={loading} />
                        <span>{th(formik.values.isPublic ? 'lmsTrainingDocument.visibilityPublic' : 'lmsTrainingDocument.visibilityPrivate')}</span>
                    </div>
                </div>

                <div className="field col-12">
                    <label>
                        {th('lmsTrainingDocument.file')} <span className="text-red-500">*</span>
                    </label>
                    <GenericFileUpload newFiles={formik.values.files} onFilesChange={onFilesChange} multiple acceptedFileTypes={PDF_TYPES} disabled={loading} />
                    {invalid('files') && <small className="p-error block">{formik.errors.files}</small>}
                </div>
            </div>
        </Dialog>
    );
};

export default TrainingDocumentAddDialog;
